export default "__VITE_ASSET__CMhDFezh__"